import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/tech-academy-apac/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Slack</AnchorLink>
  <AnchorLink mdxType="AnchorLink">What is the APAC SKO Virtual Tech Academy?</AnchorLink>
  <AnchorLink mdxType="AnchorLink">APAC SKO Virtual Tech Academy Format</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Agenda</AnchorLink>
    </AnchorLinks>
    <hr></hr>
    <h2>{`Slack`}</h2>
    <p><strong parentName="p">{`Slack channel`}</strong>{`: #sko-techacademy-integration-apac`}</p>
    <p><strong parentName="p">{`Join slack channel here`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://ibm-technology-sales.slack.com/archives/C041RNAEGNQ"
      }}>{`https://ibm-technology-sales.slack.com/archives/C041RNAEGNQ`}</a></p>
    <hr></hr>
    <h2>{`What is the APAC SKO Virtual Tech Academy?`}</h2>
    <p>{`The APAC SKO Virtual Tech Academy is a virtual event that is replacing the originally planned, face-to-fact, AKO Technical Academy event.  However, the goals and objectives for this virtual event remain the same.`}</p>
    <ul>
      <li parentName="ul">{`Develop keeper skills and knowledge in the IBM Integration portfolio to effectively plan, Configure and run a client facing PoC / MVP activity.`}</li>
      <li parentName="ul">{`Develop skills and knowledge that can be sued to demonstrate IBMs marketplace differentiations in agile integration and cloud-native development using IBM Integration an RHOCP capabilities (GitOps Automation).`}</li>
      <li parentName="ul">{`Develop skills that can be used to demonstrate IBMs market differentiation in the Event Driven Architecture (EDA) domain.  Including development skill for creating and EDA-based MVP solution.`}</li>
    </ul>
    <p>{`Attendees will develop deeper skill in the following key focus areas and technologies; CP4i / RHOCP architecture & sizing, IBM Event Streams, Kafka, RH GitOps & RH Pipeline Operators, ArgoCD, and more.`}</p>
    <hr></hr>
    <h2>{`APAC SKO Virtual Tech Academy Format`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Planning for three (3) full days of content.  Each day being 6 hrs. long (plus a 1-hour lunch break), 18 hours of total content.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`APAC Tech Leaders have agreed to September 20, 21 and 22 for delivery.  Scheduling is aligned to the Singapore time zone (SGT +8 GMT).`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Band Tech Sellers, Client Engineering, Client Success Managers, Partner Tech Sellers, Partners.  Top head count around 50 attendees.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Assign attendees into team of two (2) paired programing experience on labs and workshops.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Attempt to assign students based on skill and experience levels.  Pair senior/experiences individuals w/ our junior attendees.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`We will need to provide a list of pre-work assignments.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Each session will be a mix of presentation and hands-on lab or exercise work.  This hands-on work may (could) be defined as homework assignments.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Begin the new next day with a review and Q&A from the prior day topics and exercise work.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`WW Time Zone Alignment & Session Scheduling.`}</p>
      </li>
    </ul>
    <hr></hr>
    <h2>{`Agenda`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://ibm.box.com/s/3x1k55q9fezqlv3fp270o0fgnfsvx6bp"
        }}>{`Agenda`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      